import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, EditFormContent, BaasicButton} from 'core/components';

function ApplicationSettingEditTemplate({ editView }) {
    const {
        form,
        name
    } = editView;
    return ( 
        <div>
            <div className="modal__header">
                <h3 className='modal__header__title'>Name: {name}</h3>
            </div>
            <EditFormContent form={form}>
                <div className="form__group u-mar--bottom--sml">
                    <BasicInput field={form.$('value')} />
                </div>
                <div className="modal__footer is-right">
                    <BaasicButton
                        type='submit'
                        className='btn btn--med btn--primary'
                        label="Submit"
                        rotate
                        icon={
                            form.submitting || form.validating
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                        disabled={form.submitting || form.validating}
                        onClick={form.onSubmit}
                    />
                </div>    
            </EditFormContent>
        </div>
    )
}

ApplicationSettingEditTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ApplicationSettingEditTemplate);
